import axios from "../axios";

const getTransaction = async function (accessToken, uuid ,params = {}) {
    try {
        const response = await axios.post('/bank-transaction/getTransaction',params, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getTransaction;
